import { Component, OnInit } from '@angular/core';
import { ConfigManagerService } from './shared/services/config-manager.service';

@Component({
    selector: '<qm-redirect-rd></qm-redirect-rd>',
    template: ''
})
export class RedirectRDComponent implements OnInit {
    constructor(private configManagerService: ConfigManagerService) {}

    ngOnInit() {
        window.location.href = `${this.configManagerService.retailerDashboardUrl}`;
    }
}
